import Navbar from "@/components/Navbar";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import FeaturesOverview from "@/components/FeaturesOverview";
import RecognitionProblem from "@/components/RecognitionProblem";
import Footer from "@/components/Footer";
import DemoSection from "@/components/DemoSection";
import FAQ from "@/components/FAQ";
import SEOContent from "@/components/SEOContent";
import CoreFeatures from "@/components/CoreFeatures";
import OptimizedSolutionsGrid from "@/components/OptimizedSolutionsGrid";
import Testimonials from "@/components/Testimonials";

export { Page }

function Page() {
  return (
    <div className="relative min-h-screen w-full bg-white">
      <div className="w-full overflow-hidden">
        <Navbar />
        <div className="absolute top-[4.5rem] lg:top-[4.5rem] 2xl:top-[5rem] left-0 right-0 z-40">
          <AnnouncementBanner />
        </div>
        <main className="w-full pt-0 mt-0">
          <div className="space-y-0">
            <Hero />
            <Stats />
            
            <div className="bg-gradient-to-b from-white to-gray-50">
              <FeaturesOverview />
            </div>
            
            <CoreFeatures />
            
            <div className="bg-gradient-to-b from-white to-gray-50">
              <div className="py-6 lg:py-8"></div>
              <RecognitionProblem />
            </div>
            
            <OptimizedSolutionsGrid />
            
            <Testimonials />
            
          </div>
        </main>
        <DemoSection />
        <div className="w-full bg-gradient-to-b from-white to-gray-50">
          <SEOContent />
          <FAQ />
        </div>
        <Footer />
      </div>
    </div>
  );
}